import { FC } from 'react'

import styled from 'styled-components'

import { MetaAdsCampaignDetails } from 'src/Redux/metaAdsDetailsApi'
import { StatsBlock } from 'src/Components/StatsSectionBlock'
import { numberFormatCommas } from 'src/Constants/functions'
import { HORIZONTAL_AMOUNT } from 'src/Constants/constants'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { CampaignPaymentState } from 'src/Redux/artistOrderApi/campaignPayment'

import {
  getCampaignBudget,
  getSpentAmount,
  getMetaAdsAutoRenewVisibility,
} from '../helpers'

import CampaignHeader from './CampaignHeader'
import { MetaAdsAutoRenewBlock } from './MetaAdsAutoRenewBlock'

type Props = MetaAdsCampaignDetails & {
  paymentState?: CampaignPaymentState | null
}

const Container = styled.div`
  display: flex;
  width: 320px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  position: sticky;
  top: 0px;
  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    position: relative;
    width: 100%;
    gap: 48px;
  }
`

export const MetaAdsContent: FC<Props> = (props) => {
  const spent = getSpentAmount(props)
  const budget = getCampaignBudget(props)

  const sections = [
    {
      title: 'Budget',
      value: `$${numberFormatCommas(budget)}`,
    },
    {
      title: 'Spent',
      value: `$${numberFormatCommas(spent)}`,
    },
    {
      title: 'Daily budget',
      value: `$${numberFormatCommas(props.dailyBudget)}`,
    },
  ]

  const isStatsVisible =
    props.status === 'running' ||
    props.status === 'scheduled' ||
    props.status === 'ended'

  const { isAutoRenewActiveVisible } = getMetaAdsAutoRenewVisibility(
    props.status,
    props.shouldAutoRenew,
  )

  return (
    <Container>
      <CampaignHeader {...props} />
      {isStatsVisible && (
        <StatsBlock
          sections={sections}
          $isHorizontal={sections.length <= HORIZONTAL_AMOUNT}
        />
      )}
      {isAutoRenewActiveVisible && (
        <MetaAdsAutoRenewBlock
          campaignId={props.id}
          shouldAutoRenew={props.shouldAutoRenew}
          endDate={props.endDate}
          daysCount={props.daysCount}
        />
      )}
    </Container>
  )
}
